export default __webpack_public_path__ + "static/media/email.d5675aa9.svg";